export default __webpack_public_path__ + "static/media/PIHE.ccc1c724.png";